import { createContext } from "react";

import type { UserId } from "@core/domains/identity";
import type { ApiCallers } from "@core/ports/http";

import type { calorieGridApi } from "@apis/calorie-grid/api";

export interface AuthContextValue {
  readonly api: { readonly calorieGrid: ApiCallers<typeof calorieGridApi> };
  readonly userId: UserId;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
